/* Shopify Cookie Banner – Logo + Overlay
   Portiert von Wunschmoment. Logo-Selektor an Enterprise-Theme angepasst
   (.logo__link img statt Dawns .header__heading-logo). */
(function () {
  function findAncestorZIndex(el) {
    while (el && el !== document.body) {
      var z = window.getComputedStyle(el).zIndex;
      if (z && z !== 'auto') return parseInt(z);
      el = el.parentElement;
    }
    return null;
  }

  function getLogoSrc() {
    // Bevorzugt: dediziertes Cookie-Banner-Logo aus den Theme-Einstellungen
    // (transparentes PNG, via layout/theme.liquid gerendert).
    if (window.__wmCookieLogo) return window.__wmCookieLogo;
    // Fallback: Header-Logo (kann shop.brand.logo / JPG sein).
    var headerLogo = document.querySelector('.logo__link img');
    return headerLogo ? (headerLogo.currentSrc || headerLogo.src) : null;
  }

  function customizeBanner() {
    var banner = document.querySelector('.shopify-pc__banner__dialog');
    var title = document.getElementById('shopify-pc__banner__body-title');
    var logoSrc = getLogoSrc();
    if (!banner || !title || !logoSrc) return false;

    var logo = document.createElement('img');
    logo.src = logoSrc;
    logo.alt = 'Wunschkalender';
    logo.className = 'shopify-pc__banner__logo';
    title.parentNode.insertBefore(logo, title);

    var overlay = document.createElement('div');
    overlay.className = 'shopify-pc__banner__overlay';
    overlay.textContent = '​';
    var z = findAncestorZIndex(banner);
    overlay.style.zIndex = String(z ? z - 1 : 999999);
    document.body.appendChild(overlay);

    function removeOverlay() {
      if (overlay && overlay.parentNode) overlay.remove();
    }

    var acceptBtn = document.getElementById('shopify-pc__banner__btn-accept');
    if (acceptBtn) acceptBtn.addEventListener('click', removeOverlay);

    document.addEventListener('click', function (e) {
      if (e.target.closest('#shopify-pc__prefs__header-accept, #shopify-pc__prefs__header-save')) {
        removeOverlay();
      }
    });

    return true;
  }

  if (!customizeBanner()) {
    var observer = new MutationObserver(function () {
      if (customizeBanner()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
